import { render, staticRenderFns } from "./reportdetail.vue?vue&type=template&id=813af73e"
import script from "./reportdetail.vue?vue&type=script&lang=js"
export * from "./reportdetail.vue?vue&type=script&lang=js"
import style0 from "./reportdetail.vue?vue&type=style&index=0&id=813af73e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports